import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { Grid, Button } from '@mui/material';
import { ThemeProvider } from "@emotion/react";
import { btnTheme } from '../../Common/Theme';
import { PrintOutlined } from '@mui/icons-material';
import { CreditNoteProdDetail } from '../../Shared/Types/creditnote';
import ExchangePDF from './ExchangePDF';

interface PrintButtonsProps {
    customerName: string;
    customerContact: string;
    dtSequenceNo: string;
    netTotal: any;
    creditNoteProdDetails: CreditNoteProdDetail[];
    disabled: any;
    isCreditNote?: boolean;
    onAfterPrint?: () => void;
}

const PrintButton: React.FC<PrintButtonsProps> = ({ customerName, customerContact, dtSequenceNo, netTotal, creditNoteProdDetails, disabled, isCreditNote, onAfterPrint }) => {
    const componentRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <ThemeProvider theme={btnTheme}>
                <Grid item>
                    <ReactToPrint
                        trigger={() => (
                            <Button disabled={disabled} variant="contained">
                                <PrintOutlined />&nbsp;Preview & Print
                            </Button>
                        )}
                        content={() => componentRef.current}
                        onAfterPrint={onAfterPrint}
                    />
                </Grid>
            </ThemeProvider>

            <div id="downloadInvoice" style={{ position: 'absolute', width: '794px', height: '559px', left: '-999%' }}>
                <ExchangePDF
                    creditNoteProdDetails={creditNoteProdDetails}
                    customerContact={customerContact}
                    customerName={customerName}
                    netTotal={netTotal}
                    ref={componentRef}
                    dtSequenceNo={dtSequenceNo}
                    isCreditNote={isCreditNote}
                />
            </div>
        </>
    );
}

export default PrintButton;
